module.exports = __webpack_public_path__ + "img/input-icon.a73ffe9e.svg";